import React from "react";
import { useLang } from "../../lib/LanguageContext";
import SectionHeading from "../SectionHeading";

export default function LaunchingSoon() {
    const { t } = useLang();
    return (
        <section
            id="launch"
            className="relative py-20 sm:py-24 md:py-32 border-t border-[color:var(--sau-border)] overflow-hidden"
            data-testid="sau-launch"
        >
            <div
                className="absolute inset-0 pointer-events-none"
                style={{
                    background:
                        "radial-gradient(600px 260px at 50% 10%, rgba(102, 227, 255, 0.08), transparent 60%)",
                }}
                aria-hidden
            />
            <div className="relative max-w-7xl mx-auto px-5 sm:px-6 lg:px-10">
                <div className="grid grid-cols-1 lg:grid-cols-12 gap-10 lg:gap-12 items-start">
                    <div className="lg:col-span-5">
                        <SectionHeading eyebrow={t.launch.eyebrow} title={t.launch.title} />
                        <p className="sau-reveal mt-5 sm:mt-6 text-[15px] sm:text-base md:text-lg text-[color:var(--sau-text-2)] leading-relaxed">
                            {t.launch.body}
                        </p>
                        <div className="sau-reveal mt-6 sm:mt-8 inline-flex items-center gap-3 px-4 h-10 rounded-full border border-[color:var(--sau-border)] bg-[#0B1A2B]">
                            <span className="sau-badge-dot" />
                            <span className="text-[13px] sm:text-sm text-[color:var(--sau-text)]">{t.launch.highlight}</span>
                        </div>
                    </div>

                    <div className="lg:col-span-7">
                        <ol className="relative space-y-3">
                            {t.launch.stages.map((s, i) => (
                                <li key={`stage-${i}`} className="sau-reveal">
                                    <div className="sau-card rounded-2xl p-5 sm:p-6 flex items-start gap-4 sm:gap-5">
                                        <div className="flex-shrink-0 w-9 h-9 sm:w-10 sm:h-10 rounded-full border border-[color:var(--sau-border)] flex items-center justify-center text-[color:var(--sau-accent)] text-[13px] sm:text-sm font-semibold">
                                            {s.k}
                                        </div>
                                        <div className="flex-1 min-w-0">
                                            <div className="flex flex-wrap items-center justify-between gap-x-3 gap-y-1">
                                                <h3 className="text-[15px] sm:text-base md:text-lg font-semibold text-[color:var(--sau-text)]">
                                                    {s.t}
                                                </h3>
                                                <span
                                                    className={`text-[10px] uppercase tracking-[0.22em] sm:tracking-[0.24em] ${
                                                        i === 0
                                                            ? "text-[color:var(--sau-accent)]"
                                                            : "text-[color:var(--sau-muted)]"
                                                    }`}
                                                >
                                                    {i === 0 ? t.launch.statuses.inProgress : t.launch.statuses.upcoming}
                                                </span>
                                            </div>
                                            <p className="mt-2 text-[13.5px] sm:text-sm text-[color:var(--sau-text-2)] leading-relaxed">
                                                {s.d}
                                            </p>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ol>
                    </div>
                </div>
            </div>
        </section>
    );
}
